module.exports = __webpack_public_path__ + "img/sucess.f9728d13.svg";